import React from 'react';
import { Box } from '@mui/material';
import { uniq } from 'lodash';
import { ConfirmationDeleteWithListProps } from './ConfirmationDeleteWithList.props';
import { Message, MessagesContainer } from './ConfirmationDeleteWithList.styles';

const ConfirmationDeleteWithList = ({ reasons = [], messages, itemName }: ConfirmationDeleteWithListProps) => {
  const uniqueMessages = uniq(messages);

  return (
    <Box display="flex" flexDirection="column" justifyContent="center">
      <Box alignSelf="start">
        {uniq(reasons).map(reason => (
          <p key={reason}>{reason}</p>
        ))}
        {messages?.length ? (
          <>
            {messages.length >= 2 && <p>By deleting this {itemName}, you would also be deleting:</p>}
            <MessagesContainer>
              {uniqueMessages.map(message => (
                <Message key={message}>{message}</Message>
              ))}
            </MessagesContainer>
          </>
        ) : (
          <p>By deleting this {itemName} all information related will be lost. This process cannot be undone.</p>
        )}
      </Box>
    </Box>
  );
};

export default ConfirmationDeleteWithList;
